import { useEffect, useState } from "react";
import { X, Cookie } from "lucide-react";

const STORAGE_KEY = "sciink_cookie_consent_v1";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved =
      typeof window !== "undefined" && localStorage.getItem(STORAGE_KEY);
    if (!saved) {
      const t = setTimeout(() => setVisible(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const persist = (value) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ value, ts: new Date().toISOString() })
      );
    } catch (e) {
      /* ignore */
    }
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-label="Cookie consent"
      className="fixed bottom-4 left-4 right-4 md:bottom-6 md:left-6 md:right-auto md:max-w-md z-[70] bg-white border border-[var(--sci-border)] shadow-[0_18px_50px_-12px_rgba(11,22,44,0.25)] animate-in"
    >
      <div className="p-5 md:p-6">
        <div className="flex items-start gap-3 mb-3">
          <Cookie size={18} className="text-[var(--sci-teal)] mt-0.5 shrink-0" />
          <div>
            <div className="overline text-[var(--sci-text-muted)] mb-1.5">
              Cookies & Privacy
            </div>
            <h3 className="font-serif-display text-lg text-[var(--sci-navy)] leading-tight">
              We respect your privacy.
            </h3>
          </div>
          <button
            type="button"
            aria-label="Close cookie notice"
            data-testid="cookie-close"
            onClick={() => setVisible(false)}
            className="ml-auto text-[var(--sci-text-muted)] hover:text-[var(--sci-navy)] transition-colors"
          >
            <X size={16} />
          </button>
        </div>
        <p className="text-sm text-[var(--sci-text-muted)] leading-relaxed">
          We use only the cookies needed to remember your preferences and to
          measure anonymous traffic. No advertising or third-party tracking.
          Read our{" "}
          <a
            href="/privacy"
            className="text-[var(--sci-teal)] underline decoration-dotted hover:text-[var(--sci-teal-hover)]"
          >
            Privacy Policy
          </a>
          .
        </p>
        <div className="mt-5 grid grid-cols-2 gap-2">
          <button
            type="button"
            data-testid="cookie-necessary"
            onClick={() => persist("necessary")}
            className="btn-secondary px-4 py-2.5 text-xs tracking-wide"
          >
            Only necessary
          </button>
          <button
            type="button"
            data-testid="cookie-accept-all"
            onClick={() => persist("all")}
            className="btn-primary px-4 py-2.5 text-xs tracking-wide"
          >
            Accept all
          </button>
        </div>
      </div>
    </div>
  );
}
